module.exports = __webpack_public_path__ + "static/media/8OLA27.452c02d0.jpg";